/**
 * Color Constants for various visualization states
 * Used for consistent coloring across the application
 */
export const COLORS = {
    COMPLETED: "#66F1AD",    // Green for completed
    IN_PROGRESS: "#FC8EAC",  // Pink for in-progress
    SELECTED: "#F6BE00",     // Yellow for selected
    FAILED: "red",           // Red for QC failures
    DEFAULT: "white",        // White for default/not started
    LOCKED: "#529ef1"        // Blue for locked items
};

/**
 * Legend Items for Construction Progress
 */
export const CP_LEGEND_ITEMS = [
  {
    color: COLORS.COMPLETED,
    label: 'Completed'
  },
  {
    color: COLORS.IN_PROGRESS,
    label: 'In Progress'
  },
  {
    color: COLORS.SELECTED,
    label: 'Selected'
  }
];

/**
 * Legend Items for Quality Control
 */
export const QC_LEGEND_ITEMS = [
  {
    color: COLORS.FAILED,
    label: 'Failed'
  },
  {
    color: COLORS.COMPLETED,
    label: 'Pass'
  },
  {
    color: COLORS.DEFAULT,
    label: 'Not Started'
  }
];

/**
 * Legend Items for Punchlist
 */
export const PUNCHLIST_LEGEND_ITEMS = [
  {
    color: COLORS.FAILED,
    label: 'Open'
  },
  {
    color: COLORS.IN_PROGRESS,
    label: 'Ready for Inspection'
  },
  {
    color: COLORS.COMPLETED,
    label: 'Resolved'
  }
];

/**
 * Legend Items for Lock/Unlock
 */
export const LOCK_LEGEND_ITEMS = [
  {
    color: COLORS.LOCKED,
    label: 'Lock'
  },
  {
    color: COLORS.DEFAULT,
    label: 'Unlock'
  }
];

/**
 * Legend Items for Progress Menu
 */
export const SVG_MENU_ITEMS = [
  {
    color: COLORS.COMPLETED,
    label: 'Completed'
  },
  {
    color: COLORS.IN_PROGRESS,
    label: 'In Progress'
  },
  {
    color: COLORS.DEFAULT,
    label: 'Not Started'
  }
];